/** The Telegram bot every "talk to Fin" action opens. */
export const BOT_USERNAME =
  process.env.REACT_APP_TELEGRAM_BOT_USERNAME || 'Financy_Official_Bot';
export const BOT_URL = `https://t.me/${BOT_USERNAME}`;

/**
 * Opens Telegram's "add to a group" picker with Fin, carrying the context to
 * link the group to: the bot links it on its own once the person who adds it
 * proves to be an owner or admin. `asAdmin` asks for the rights to make
 * invite links and to pin the group's instructions, and to add admins with
 * the rights to delete messages and restrict members, so the app can make
 * its admins admins there too (Telegram shows them, and the person can
 * untick them). The private chat (BOT_URL) always records
 * into the personal view, so a group's actions must never point there.
 */
export const botAddToGroupUrl = (contextId: string, options: { asAdmin: boolean }): string => {
  // Same payload the bot parses (backend/src/telegram/group-chat.ts).
  const payload = `gn${contextId.replace(/-/g, '')}`;
  return `${BOT_URL}?startgroup=${payload}${options.asAdmin ? '&admin=invite_users+pin_messages+promote_members+delete_messages+restrict_members' : ''}`;
};

/** Telegram's own "new group" screen, where people pick who joins from their contacts. */
export const NEW_TELEGRAM_GROUP_URL = 'tg://new/group';

/**
 * A group's invite link (t.me/+<hash>) in its older form, t.me/joinchat/<hash>,
 * which opens the same invite. Telegram's share screen reads a "+" in the
 * shared link as a space, even sent as %2B, and the link it sends then breaks.
 */
const withoutPlus = (url: string): string => url.replace(/^https:\/\/t\.me\/\+/, 'https://t.me/joinchat/');

/** A "+" in the message (a group's name, say) would arrive as a space too: a look-alike goes instead. */
const keepPlus = (text: string): string => text.replace(/\+/g, '＋');

/** Telegram's share picker: the person's chats and contacts, with the message ready to send. */
export const telegramShareUrl = (url: string, text: string): string =>
  `https://t.me/share/url?url=${encodeURIComponent(withoutPlus(url))}&text=${encodeURIComponent(keepPlus(text))}`;
